"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dataCy = void 0;
var _react = require("react");
var _Chip = _interopRequireDefault(require("../Chip"));
var _Grid = _interopRequireDefault(require("../Grid"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _useLimitedTags = require("./useLimitedTags");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var dataCy = exports.dataCy = 'Tags';
var defaultGetTagLabel = function defaultGetTagLabel(tag) {
  return tag;
};
var Tags = function Tags(_ref) {
  var _ref$data = _ref.data,
    dataProp = _ref$data === void 0 ? [] : _ref$data,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 0 : _ref$width,
    _ref$lineClamp = _ref.lineClamp,
    lineClamp = _ref$lineClamp === void 0 ? 1 : _ref$lineClamp,
    _ref$getTagLabel = _ref.getTagLabel,
    getTagLabel = _ref$getTagLabel === void 0 ? defaultGetTagLabel : _ref$getTagLabel;
  var ref = (0, _react.useRef)();
  var _useState = (0, _react.useState)(width),
    _useState2 = _slicedToArray(_useState, 2),
    containerWidth = _useState2[0],
    setContainerWidth = _useState2[1];
  var limitTags = (0, _useLimitedTags.useLimitedTags)({
    lineClamp: lineClamp
  });
  (0, _react.useEffect)(function () {
    var clientWidth = ref.current.clientWidth;
    if (clientWidth && clientWidth !== containerWidth) {
      setContainerWidth(clientWidth);
    }
  }, []);
  var data = dataProp.map(getTagLabel);
  var visibleData = (0, _react.useMemo)(function () {
    if (!data.length || !containerWidth) {
      return [];
    }
    var visibleCount = limitTags({
      data: data,
      containerWidth: containerWidth
    });
    return data.slice(0, visibleCount);
  }, [limitTags, data.toString(), containerWidth]);
  var otherChipLabel = (0, _react.useMemo)(function () {
    var diff = data.length - visibleData.length;
    return diff ? "...".concat(diff, " ").concat(diff > 1 ? 'tags' : 'tag') : null;
  }, [data.toString(), visibleData]);
  var otherChipTooltipText = (0, _react.useMemo)(function () {
    var diff = data.filter(function (el) {
      return !visibleData.includes(el);
    });
    return diff.length ? diff.join(', ') : '';
  }, [data.toString(), visibleData]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid["default"], {
    container: true,
    ref: ref,
    "data-cy": dataCy,
    spacing: 1,
    children: [visibleData.map(function (name, i) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid["default"], {
        item: true,
        "data-cy": name + i,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Chip["default"], {
          label: name,
          size: 'small'
        })
      }, name);
    }), otherChipLabel ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid["default"], {
      item: true,
      "data-cy": 'Other tags',
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip["default"], {
        title: otherChipTooltipText,
        wrapper: true,
        wrapperComponent: 'div',
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Chip["default"], {
          label: otherChipLabel,
          size: 'small'
        })
      })
    }) : null]
  });
};
var _default = exports["default"] = Tags;